export default defineNuxtRouteMiddleware(({ path }) => {
  if (path.includes('login')) {
    return navigateTo('/?dialog=login', {
      redirectCode: 301,
    })
  }
})
